<div class="main-content" [ngClass]="{'bg-img': isMobile}">
  <div class="p-0 d-flex" [ngClass]="{'bgg': isMobile}" style="height: 100%;">

    <div [ngClass]="{'row': isMobile}" [ngClass]="{'col-4 p-0': !isMobile}">
      <div class="col-12 p-0" [ngClass]="{'bg-left': !isMobile}">

        <div class="margin-text">
          <div class="col-12 pl-0">
            <a href="https://www.manax.es"><img src="/assets/img/manax-logo.svg" class="Lavuro-logo"
                alt="Lavuro-logo"></a>
          </div>
        </div>

        <div class="margin-text margin-text-botton">
          <div class="col-12 col-md-10 pl-0">
            <h4 class="initText">Gestiona tu empresa sin dolores de cabeza</h4>
          </div>
          <div class="col-12 col-md-10 pr-5 pr-md-3">
            <div class="row">
              <h4 class="subText"><img src="/assets/img/icons/icon-calendar.svg" alt="icono-calendar"
                  class="icon-manax mr-1">Programa servicios en tu agenda</h4><br>
            </div>
            <div class="row">
              <h4 class="subText"><img src="/assets/img/icons/icon-list.svg" alt="icono-calendar"
                  class="icon-manax mr-1">Envía presupuestos y facturas</h4><br>
            </div>
            <div class="row">
              <h4 class="subText"><img src="/assets/img/icons/icon-ubi.svg" alt="icono-calendar"
                  class="icon-manax mr-1">Controla fichajes horarios e incidencias</h4>
            </div>
          </div>
        </div>

        <div class="mb-md-5">
        </div>
      </div>
    </div>

    <div [ngClass]="{'row': isMobile}" [ngClass]="{'col-8 p-0': !isMobile}">
      <div class="p-0" [ngClass]="{'bg-right': !isMobile}">
        <h3 class="welcome-text px-3 d-none d-md-inline" *ngIf="!loading && !requestResetPassword">¡Bienvenido de nuevo!
        </h3>
        <h4 class="welcome-subtext px-3 d-none d-md-inline" *ngIf="!loading  && !requestResetPassword">Inicia Sesión
        </h4>
        <div class="row form-width" *ngIf="!loading">
          <div class="col-12 card mx-auto font-manax" *ngIf="!requestResetPassword">
            <div class="card-body">
              <h5 style="font-weight: 600; color: #9a9a9a;" class="pt-2">Introduce tus datos para iniciar sesión</h5>
              <br>
              <form [formGroup]="form" (ngSubmit)="onSubmit()">

                <div class="row">
                  <div class="col-md-12 pb-2">
                    <label for="emailForm" class="font-manax text-purple-manax margin-label-bs"
                      style="font-weight: 700;">Correo Electrónico</label>
                    <div class="input-group">
                      <input class="form-control space-form" id="emailForm" inputTrim type="text"
                        formControlName="email" [ngClass]="{ 'is-invalid': submitted && f['email'].errors }"
                        placeholder="Ingresa tu correo electrónico">
                      <div class="invalid-feedback" *ngIf="submitted && f['email'].errors">
                        Email requerido
                      </div>
                    </div>
                  </div>
                </div>

                <div class="row">
                  <div class="col-md-12 password-group pb-2">
                    <label for="passwordForm" class="font-manax text-purple-manax margin-label-bs"
                      style="font-weight: 700;">Contrase&ntilde;a</label>
                    <div class="input-group">
                      <input class="form-control space-form" id="passwordForm" inputTrim type="password"
                        placeholder="Ingresa tu contraseña" formControlName="password"
                        [ngClass]="{ 'is-invalid': submitted && f['password'].errors }" #passwordInput required>
                      <i class="material-icons password-eye cursor-pointer" [ngClass]="viewPassword ? 'text-manax' : ''"
                        (click)="togglePasswordView()">visibility</i>
                      <div class="invalid-feedback" *ngIf="submitted && f['password']?.errors?.['required']">
                        Contrase&ntilde;a requerida
                      </div>
                    </div>
                  </div>
                </div>

                <div class="row">
                  <div class="col-6 col-md-offset-4">
                    <span style="color: inherit;"> ¿Nuevo en Manax? <a href="https://app.man.ax/#/trial"
                        class="font-manax"
                        style="color: #4B39EF; cursor: pointer; font-weight: 500;">Registrarse</a></span>
                  </div>
                  <div class="col-6 col-md-offset-4">
                    <div class="pull-right"><a (click)="showRequestResetPassword()" class="font-manax"
                        style="color: #4B39EF; cursor: pointer; font-weight: 500;"> Recuperar contraseña </a></div>
                  </div>
                </div>

                <div class="row">
                  <div class="col-12 pt-4">
                    <button [disabled]="loading" class="btn btn-manax mx-auto" type="submit"
                      style="width: 100% !important; font-size: 16px; font-weight: 700;">
                      <span *ngIf="loading" class="spinner-border spinner-border-sm mr-1"></span>
                      Iniciar Sesión
                    </button>
                  </div>
                </div>
              </form>
            </div>
          </div>

          <div class="card" *ngIf="requestResetPassword">
            <div class="card-body">
              <h5 class="font-manax" style="color: #0f0755; font-weight: 700; font-size: 2rem;">Recuperar contraseña
              </h5>
              <p class="font-manax" style="font-weight: 500; color: #9a9a9a;">Ingrese su email para solicitar el cambio
                de clave</p>
              <form [formGroup]="formReset" (ngSubmit)="onSubmitReset()">
                <div class="row">
                  <div class="col-md-12">

                    <label for="recEmailForm" class="font-manax text-purple-manax margin-label-bs"
                      style="font-weight: 700;">Correo Electrónico</label>
                    <div class="input-group">
                      <input class="form-control space-form" id="recEmailForm" inputTrim type="text"
                        formControlName="email" [ngClass]="{ 'is-invalid': submitted && f['email'].errors }">
                      <div class="invalid-feedback" *ngIf="submitted && f['email'].errors">
                        Email requerido
                      </div>
                    </div>
                  </div>
                </div>

                <div class="row">
                  <div class="col-12 pt-4">
                    <button [disabled]="loading" class="btn btn-manax mx-auto" type="submit">
                      <span *ngIf="loading" class="spinner-border spinner-border-sm mr-1"></span>
                      Solicitar
                    </button>
                  </div>
                </div>
              </form>
            </div>
          </div>
        </div>

        <div class="row margin-help" *ngIf="!loading">
          <!--button [disabled]="loading" class="btn btn-manax-outline" (click)="openWhatsapp()">
            <i class="material-icons">support_agent</i>
            <span class="pl-1 support-button-text">Contactar soporte</span>
          </button-->
        </div>

      </div>
    </div>
  </div>
</div>
<!-- <div class="main-content">
  <div class="container-fluid p-0">

    <div class="col-sm-10 col-md-6 col-lg-4 mx-auto my-auto">

      <img src="/assets/img/manax-logo-black.svg" class="Lavuro-logo" alt="Lavuro-logo">

      <div class="card" *ngIf="!requestResetPassword">
        <div class="card-header card-header-manax">
          <h4 class="card-title">Iniciar Sesión</h4>
          <p class="card-category">Complete sus credenciales para acceder al sistema</p>
        </div>
        <div class="card-body">
          <form [formGroup]="form" (ngSubmit)="onSubmit()">


            <div class="row">
              <div class="col-md-12">
                <mat-form-field appearance="outline" >
                  <input matInput inputTrim placeholder="Email" type="text" formControlName="email"
                    [ngClass]="{ 'is-invalid': submitted && f.email.errors }" />
                  <mat-error *ngIf="submitted && f.email.errors">
                    Email requerido
                  </mat-error>
                </mat-form-field>
              </div>
            </div>

            <div class="row">
              <div class="col-md-12 password-group">
                <mat-form-field class="example-full-width">
                  <input matInput inputTrim placeholder="Contrase&ntilde;a" type="password" formControlName="password"
                    [ngClass]="{ 'is-invalid': submitted && f.password?.errors }" #passwordInput />
                  <mat-error *ngIf="submitted && f.password?.errors?.required">
                    Contrase&ntilde;a requerida
                  </mat-error>
                </mat-form-field>

                <i class="material-icons password-eye cursor-pointer" [ngClass]="viewPassword ? 'text-manax' : ''"
                  (click)="togglePasswordView()">visibility</i>
              </div>
            </div>

            <div class="row">
              <div class="col-6 col-md-offset-4">
                <span style="color: inherit;"> ¿Nuevo en Manax? <a href="https://app.man.ax/#/trial" style="color: #2B69DB; cursor: pointer;">Registrarse</a></span>
              </div>
              <div class="col-6 col-md-offset-4">
                <div class="pull-right"><a (click)="showRequestResetPassword()" style="cursor: pointer; color: #2B69DB;"> Recuperar contraseña </a></div>
              </div>
            </div>

            <div class="row">
              <div class="col-12 pt-4">
                <button [disabled]="loading" class="btn btn-manax mx-auto" type="submit">
                  <span *ngIf="loading" class="spinner-border spinner-border-sm mr-1"></span>
                  Ingresar
                </button>
              </div>
            </div>
          </form>
        </div>
      </div>

      <div class="card" *ngIf="requestResetPassword">
        <div class="card-header card-header-manax">
          <h4 class="card-title">Recuperar contraseña</h4>
          <p class="card-category">Ingrese su email para solicitar el cambio de clave</p>
        </div>
        <div class="card-body">
          <form [formGroup]="formReset" (ngSubmit)="onSubmitReset()">
            <div class="row">
              <div class="col-md-12">
                <mat-form-field appearance="outline" >
                  <input matInput inputTrim placeholder="Email" type="text" formControlName="email"
                    [ngClass]="{ 'is-invalid': submitted && f.email.errors }" />
                  <mat-error *ngIf="submitted && f.email.errors">
                    Email requerido
                  </mat-error>
                </mat-form-field>
              </div>
            </div>

            <div class="row">
              <div class="col-12 pt-4">
                <button [disabled]="loading" class="btn btn-manax mx-auto" type="submit">
                  <span *ngIf="loading" class="spinner-border spinner-border-sm mr-1"></span>
                  Solicitar
                </button>
              </div>
            </div>
          </form>
        </div>
      </div>

    </div>

  </div>
</div> -->